import { Table, Text } from '@factorialco/deprecated-design-system'
import {
  SaleInvoiceComplianceExtraFieldsFieldFragment,
  SaleInvoiceDetailLineItemFragment,
} from 'generated/resources/graphql'

import { formattedAmount } from 'modules/banking/lib/paymentHelpers'
import { formatTaxRate } from 'modules/finance/lib/invoices'

interface LineItemRowProps {
  lineItem: SaleInvoiceDetailLineItemFragment
  currency?: string | null
  locale: string
  complianceExtraFields?: SaleInvoiceComplianceExtraFieldsFieldFragment[] | null
}

export const LineItemRow: React.FC<LineItemRowProps> = ({
  lineItem,
  currency,
  locale,
  complianceExtraFields,
}) => {
  return (
    <Table.Row>
      <Table.Cell style={{ maxWidth: '300px' }}>
        <Text.Normal size="200" weight="medium" color="grey1000" lineClamp={2}>
          {lineItem.description || ''}
        </Text.Normal>
      </Table.Cell>
      <Table.Cell>
        <Text.Normal size="200" weight="normal" color="grey1000">
          {lineItem.quantity ?? ''}
        </Text.Normal>
      </Table.Cell>
      <Table.Cell style={{ textAlign: 'right' }}>
        <Text.Normal size="200" weight="normal" color="grey1000">
          {currency && locale && lineItem.amountCents
            ? formattedAmount({ amountCents: lineItem.amountCents, currency, locale })
            : ''}
        </Text.Normal>
      </Table.Cell>
      <Table.Cell>
        <Text.Normal size="200" weight="normal" color="grey1000">
          {formatTaxRate(lineItem?.taxRatePercentage)}
        </Text.Normal>
      </Table.Cell>
      <Table.Cell style={{ textAlign: 'right' }}>
        <Text.Normal size="200" weight="normal" color="grey1000">
          {currency && locale && lineItem.amountCents && lineItem.quantity
            ? formattedAmount({
                amountCents: lineItem.amountCents * lineItem.quantity,
                currency,
                locale,
              })
            : ''}
        </Text.Normal>
      </Table.Cell>
      {complianceExtraFields &&
        complianceExtraFields.map((field) => (
          <Table.Cell key={field.name}>
            <Text.Normal size="200" weight="normal" color="grey1000">
              {field.value}
            </Text.Normal>
          </Table.Cell>
        ))}
    </Table.Row>
  )
}
